import { motion } from "framer-motion";
import { useInView } from "framer-motion";
import { useRef, useState } from "react";
import { toast } from "sonner";
import { ArrowRight } from "lucide-react";

const API_URL = process.env.REACT_APP_BACKEND_URL;

const Newsletter = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-50px" });
  const [firstName, setFirstName] = useState("");
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await fetch(`${API_URL}/api/community/signup`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, firstName }),
      });
      if (res.ok) {
        toast.success("Welcome to Future Signals! You're in.");
        setFirstName("");
        setEmail("");
      } else {
        const data = await res.json();
        toast.error(data.detail || "Something went wrong.");
      }
    } catch {
      toast.error("Connection error. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section ref={ref} className="py-20 md:py-28 bg-[var(--bg-primary)] relative" data-testid="newsletter-section">
      <div className="max-w-4xl mx-auto px-6 md:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className="bg-[var(--bg-card)] border-glow rounded-2xl p-8 md:p-12"
        >
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold text-white italic mb-3" data-testid="newsletter-heading">
            Future Signals
          </h2>
          <p className="text-[var(--text-secondary)] text-lg mb-8">
            What AI is changing. Why it matters. What comes next.
          </p>

          <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-3">
            <input
              type="text"
              placeholder="First Name"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              className="px-5 py-3.5 bg-[var(--bg-secondary)] border border-[rgba(124,58,237,0.15)] rounded-lg text-white placeholder:text-[var(--text-secondary)] focus:border-[var(--accent-violet)] focus:outline-none transition-colors flex-1"
              data-testid="newsletter-name-input"
            />
            <input
              type="email"
              placeholder="Email Address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="px-5 py-3.5 bg-[var(--bg-secondary)] border border-[rgba(124,58,237,0.15)] rounded-lg text-white placeholder:text-[var(--text-secondary)] focus:border-[var(--accent-violet)] focus:outline-none transition-colors flex-1"
              data-testid="newsletter-email-input"
            />
            <button
              type="submit"
              disabled={loading}
              className="bg-[var(--accent-violet)] hover:bg-[#6d28d9] text-white px-7 py-3.5 rounded-lg font-semibold transition-all flex items-center justify-center gap-2 disabled:opacity-60 whitespace-nowrap"
              data-testid="newsletter-submit-btn"
            >
              {loading ? "Subscribing..." : "Subscribe"}
              {!loading && <ArrowRight className="w-4 h-4" />}
            </button>
          </form>

          <p className="text-xs text-[var(--text-secondary)]/60 mt-4">
            By subscribing you agree to receive Future Signals. Unsubscribe anytime. No spam, ever.
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default Newsletter;
